import { useEffect, useLayoutEffect } from 'react';
import { useModalContext } from 'components/Modal/ModalProvider';

export const useModal = () => {
  const { modal, openModal, closeModal } = useModalContext();

  return {
    modal,
    openModal,
    closeModal,
    isModalOpened: modal.type !== null,
  };
};


const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useScrollLock = (locked: boolean) => {
  useIsomorphicLayoutEffect(() => {
    if (!locked) return;

    const scrollY = window.scrollY;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';

      window.scrollTo(0, scrollY);
    };
  }, [locked]);
};